<dx-popup [(visible)]="DashboardFilterService.isFilterOpen" [showTitle]="true" [title]="popupTitle"
    [dragEnabled]="false" [hideOnOutsideClick]="true" [showCloseButton]="true" [width]="'600'" [maxWidth]="'95vw'"
    [height]="'auto'" [maxHeight]="'85vh'" container=".dx-viewport" (onHiding)="onHiding()"
    class="hierarchy-filter-popup">

    <div *dxTemplate="let data of 'content'" class="hierarchy-filter-content">

        <!-- Loader overlay while cascade dropdowns are fetching -->
        <div class="filter-loading-overlay" *ngIf="isLoading">
            <dx-load-indicator [visible]="true" height="40" width="40"></dx-load-indicator>
            <span class="filter-loading-text">{{ langService.currentLang === 'mr' ? 'लोड होत आहे...' : 'Loading...'
                }}</span>
        </div>

        <!-- Scrollable body: all filter rows -->
        <dx-scroll-view class="filter-scroll-body" direction="vertical" [showScrollbar]="onScroll" [useNative]="false"
            [bounceEnabled]="false">

            <!-- State / Zone -->
            <div class="filter-row"
                *ngIf="DashboardFilterService.IsStateVisible || DashboardFilterService.IsZoneVisible">
                <div class="filter-field" *ngIf="DashboardFilterService.IsStateVisible">
                    <label class="lable" for="StateRef">{{ langService.currentLang === 'mr' ? 'राज्य' : 'State' }}</label>
                    <dx-tag-box id="StateRef" [(ngModel)]="DashboardFilterService.state_ids"
                        [items]="DashboardFilterService.StateList" [displayExpr]="getStateDisplay" valueExpr="p.id"
                        name="StateRef" [searchExpr]="['p.name_en', 'p.name_mr', 'p.name']"
                        [disabled]="DashboardFilterService.IsStateDisabled || DashboardFilterService.StateList.length === 0"
                        [placeholder]="langService.currentLang === 'mr' ? 'सर्व राज्य' : 'All State'"
                        [showSelectionControls]="true" [searchEnabled]="true" [showClearButton]="true"
                        [showDropDownButton]="true" [dropDownOptions]="tagBoxDropDownOptions" [maxDisplayedTags]="1"
                        (onValueChanged)="DashboardFilterService.onStateChanged($event)">
                    </dx-tag-box>
                </div>

                <div class="filter-field" *ngIf="DashboardFilterService.IsZoneVisible">
                    <label class="lable" for="ZoneRef">{{ langService.currentLang === 'mr' ? 'विभाग' : 'Zone' }}</label>
                    <dx-tag-box id="ZoneRef" [(ngModel)]="DashboardFilterService.zone_ids"
                        [items]="DashboardFilterService.ZoneList" [displayExpr]="getZoneDisplay" valueExpr="p.id" name="ZoneRef"
                        [placeholder]="langService.currentLang === 'mr' ? 'सर्व विभाग' : 'All Zone'"
                        [disabled]="DashboardFilterService.IsZoneDisabled || DashboardFilterService.ZoneList.length === 0"
                        [showDropDownButton]="true" [showSelectionControls]="true" [searchEnabled]="true"
                        [searchExpr]="['p.name', 'p.name_en', 'p.name_mr']" [showClearButton]="true"
                        (onValueChanged)="DashboardFilterService.onZoneChanged($event)" [maxDisplayedTags]="1"
                        [dropDownOptions]="tagBoxDropDownOptions">
                    </dx-tag-box>
                </div>
            </div>

            <!-- District / Block -->
            <div class="filter-row"
                *ngIf="DashboardFilterService.IsDistrictVisible || DashboardFilterService.IsBlockVisible">
                <div class="filter-field" *ngIf="DashboardFilterService.IsDistrictVisible">
                    <label class="lable" for="DistrictRef">{{ langService.currentLang === 'mr' ? 'जिल्हा' : 'District' }}</label>
                    <dx-tag-box id="DistrictRef" [(ngModel)]="DashboardFilterService.district_ids"
                        [items]="DashboardFilterService.DistrictList" [displayExpr]="getDistrictDisplay"
                        valueExpr="p.id" name="DistrictRef" [searchExpr]="['p.name_en', 'p.name_mr', 'p.name']"
                        [disabled]="DashboardFilterService.IsDistrictDisabled || DashboardFilterService.DistrictList.length === 0"
                        [placeholder]="langService.currentLang === 'mr' ? 'सर्व जिल्हा' : 'All District'"
                        [showDropDownButton]="true" [showSelectionControls]="true" [searchEnabled]="true"
                        [showClearButton]="true" (onValueChanged)="DashboardFilterService.onDistrictChanged($event)"
                        [maxDisplayedTags]="1" [dropDownOptions]="tagBoxDropDownOptions">
                    </dx-tag-box>
                </div>

                <div class="filter-field" *ngIf="DashboardFilterService.IsBlockVisible">
                    <label class="lable" for="BlockRef">{{ langService.currentLang === 'mr' ? 'तालुका' : 'Block' }}</label>
                    <dx-tag-box id="BlockRef" [(ngModel)]="DashboardFilterService.block_ids"
                        [items]="DashboardFilterService.BlockList" [displayExpr]="getBlockDisplay" valueExpr="p.id"
                        [searchExpr]="['p.name_en', 'p.name_mr', 'p.name']"
                        [disabled]="DashboardFilterService.IsBlockDisabled || DashboardFilterService.BlockList.length === 0"
                        [placeholder]="langService.currentLang === 'mr' ? 'सर्व तालुका' : 'All Block'"
                        [showDropDownButton]="true" [showSelectionControls]="true" [searchEnabled]="true"
                        [showClearButton]="true" [dropDownOptions]="tagBoxDropDownOptions"
                        (onValueChanged)="DashboardFilterService.onBlockChanged($event)" [maxDisplayedTags]="1">
                    </dx-tag-box>
                </div>
            </div>

            <!-- BCM / PHC -->
            <div class="filter-row"
                *ngIf="DashboardFilterService.IsBCMPostVisible || DashboardFilterService.IsPHCVisible">
                <div class="filter-field" *ngIf="DashboardFilterService.IsBCMPostVisible">
                    <label class="lable" for="BCMPostRef">{{ langService.currentLang === 'mr' ? 'बीसीएम नाव' : 'BCM Name' }}</label>
                    <dx-tag-box id="BCMPostRef" [(ngModel)]="DashboardFilterService.bcm_post_ids"
                        [items]="DashboardFilterService.BCMPostList" [displayExpr]="getBCMDisplay" valueExpr="p.id"
                        [searchExpr]="['p.full_name', 'p.full_name_mr', 'p.name', 'p.name_mr', 'p.asha_full_name', 'p.asha_full_name_mr']"
                        [disabled]="DashboardFilterService.IsBCMPostDisabled || DashboardFilterService.BCMPostList.length === 0"
                        [placeholder]="langService.currentLang === 'mr' ? 'सर्व बीसीएम' : 'All BCM'"
                        [showDropDownButton]="true" [showSelectionControls]="true" [searchEnabled]="true"
                        [showClearButton]="true" [dropDownOptions]="tagBoxDropDownOptions"
                        (onValueChanged)="DashboardFilterService.onBCMPostChanged($event)" [maxDisplayedTags]="1">
                    </dx-tag-box>
                </div>

                <div class="filter-field" *ngIf="DashboardFilterService.IsPHCVisible">
                    <label class="lable" for="PHCRef">{{ langService.currentLang === 'mr' ? 'प्रा.आ.केंद्र' : 'PHC' }}</label>
                    <dx-tag-box id="PHCRef" [(ngModel)]="DashboardFilterService.phc_ids"
                        [items]="DashboardFilterService.PHCList" [displayExpr]="getPHCDisplay" valueExpr="p.id"
                        [searchExpr]="['p.name', 'p.name_mr', 'p.name_en']"
                        [placeholder]="langService.currentLang === 'mr' ? 'सर्व प्रा.आ.केंद्र' : 'All PHC'"
                        [showSelectionControls]="true" [searchEnabled]="true" [showDropDownButton]="true"
                        [showClearButton]="true"
                        [disabled]="DashboardFilterService.IsPHCDisabled || DashboardFilterService.PHCList.length === 0"
                        [dropDownOptions]="tagBoxDropDownOptions"
                        (onValueChanged)="DashboardFilterService.onPHCChanged($event)" [maxDisplayedTags]="1">
                    </dx-tag-box>
                </div>
            </div>

            <!-- AF / SC -->
            <div class="filter-row"
                *ngIf="DashboardFilterService.IsAFPostVisible || DashboardFilterService.IsSCVisible">
                <div class="filter-field" *ngIf="DashboardFilterService.IsAFPostVisible">
                    <label class="lable" for="AFPostRef">{{ langService.currentLang === 'mr' ? 'आशा गटप्रवर्तक' : 'AF' }}</label>
                    <dx-tag-box id="AFPostRef" [(ngModel)]="DashboardFilterService.af_ids"
                        [items]="DashboardFilterService.AFList" [displayExpr]="getAFDisplay" valueExpr="p.id"
                        [searchExpr]="['p.full_name', 'p.full_name_mr', 'p.name', 'p.name_mr', 'p.asha_full_name', 'p.asha_full_name_mr']"
                        [placeholder]="langService.currentLang === 'mr' ? 'सर्व गटप्रवर्तक' : 'All AF'"
                        [showSelectionControls]="true" [searchEnabled]="true" [showDropDownButton]="true"
                        [showClearButton]="true"
                        [disabled]="DashboardFilterService.IsAFPostDisabled || DashboardFilterService.AFList.length === 0"
                        [dropDownOptions]="tagBoxDropDownOptions"
                        (onValueChanged)="DashboardFilterService.onAFPostChanged($event)" [maxDisplayedTags]="1">
                    </dx-tag-box>
                </div>

                <div class="filter-field" *ngIf="DashboardFilterService.IsSCVisible">
                    <label class="lable" for="SCRef">{{ langService.currentLang === 'mr' ? 'उपकेंद्र' : 'SC' }}</label>
                    <dx-tag-box id="SCRef" [(ngModel)]="DashboardFilterService.sc_ids"
                        [items]="DashboardFilterService.SCList" [displayExpr]="getSCDisplay" valueExpr="p.id" name="SCRef"
                        [searchExpr]="['p.name', 'p.name_mr', 'p.name_en']"
                        [placeholder]="langService.currentLang === 'mr' ? 'सर्व उपकेंद्र' : 'All SC'"
                        [showDropDownButton]="true" [showSelectionControls]="true" [searchEnabled]="true"
                        [showClearButton]="true" [dropDownOptions]="tagBoxDropDownOptions"
                        [disabled]="DashboardFilterService.IsSCDisabled || DashboardFilterService.SCList.length === 0"
                        (onValueChanged)="DashboardFilterService.onSCChanged($event)" [maxDisplayedTags]="1">
                    </dx-tag-box>
                </div>
            </div>

            <!-- Village / Asha -->
            <div class="filter-row"
                *ngIf="DashboardFilterService.IsVillageVisible || DashboardFilterService.IsAshaVisible">
                <div class="filter-field" *ngIf="DashboardFilterService.IsVillageVisible">
                    <label class="lable" for="VillageRef">{{ langService.currentLang === 'mr' ? 'गाव' : 'Village' }}</label>
                    <dx-tag-box id="VillageRef" [(ngModel)]="DashboardFilterService.village_ids"
                        [items]="DashboardFilterService.VillageList" [displayExpr]="getVillageDisplay" valueExpr="p.id"
                        name="VillageRef" [searchExpr]="['p.name_en', 'p.name_mr', 'p.name']"
                        [placeholder]="langService.currentLang === 'mr' ? 'सर्व गाव' : 'All Village'"
                        [disabled]="DashboardFilterService.IsVillageDisabled || DashboardFilterService.VillageList.length === 0"
                        [showSelectionControls]="true" [searchEnabled]="true" [showClearButton]="true"
                        [dropDownOptions]="tagBoxDropDownOptions" [showDropDownButton]="true"
                        (onValueChanged)="DashboardFilterService.onVillageChanged($event)" [maxDisplayedTags]="1">
                    </dx-tag-box>
                </div>

                <div class="filter-field" *ngIf="DashboardFilterService.IsAshaVisible">
                    <label class="lable" for="AshaRefs">{{ langService.currentLang === 'mr' ? 'आशा' : 'Asha' }}</label>
                    <dx-tag-box id="AshaRefs" [(ngModel)]="DashboardFilterService.asha_ids"
                        [items]="DashboardFilterService.AshaList" [displayExpr]="getAshaDisplay" valueExpr="p.id"
                        name="AshaRefs" [searchExpr]="['p.asha_full_name', 'p.asha_full_name_mr', 'p.full_name', 'p.full_name_mr']"
                        [placeholder]="langService.currentLang === 'mr' ? 'सर्व आशा' : 'All Asha'"
                        [disabled]="DashboardFilterService.IsAshaDisabled || DashboardFilterService.AshaList.length === 0"
                        [showSelectionControls]="true" [searchEnabled]="true" [showClearButton]="true"
                        [dropDownOptions]="tagBoxDropDownOptions" [showDropDownButton]="true"
                        (onValueChanged)="DashboardFilterService.onAshaChanged($event)" [maxDisplayedTags]="1">
                    </dx-tag-box>
                </div>
            </div>

        </dx-scroll-view>

        <!-- Apply / Clear — sticky footer, always visible -->
        <div class="apply-btn-container">
            <dx-button [elementAttr]="filterButtonAttr" [text]="langService.currentLang === 'mr' ? 'लागू करा' : 'Apply'"
                type="default" stylingMode="contained" [disabled]="isLoading" (click)="onApplyClick()">
            </dx-button>
            <dx-button [elementAttr]="filterButtonAttr" [text]="langService.currentLang === 'mr' ? 'साफ करा' : 'Clear'"
                type="default" stylingMode="contained" [disabled]="isLoading" (click)="onClearClick()">
            </dx-button>
        </div>
    </div>
</dx-popup>